module.exports = __webpack_public_path__ + "static/img/skirmisher1.66e209b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/skirmisher1.png
// module id = +2j6
// module chunks = 0